import type { CreditCardBrandInput } from './creditcardTypes';

const getSavedCardBrand = (savedCardBrand: string): CreditCardBrandInput => {
  const SavedCardBrandMapping = new Map<string, CreditCardBrandInput>([
    ['Visa', 'VISA'],
    ['MasterCard', 'MASTER_CARD'],
    ['American Express', 'AMEX'],
    ['Unknown', 'UNKNOWN'],
  ]);

  if (!SavedCardBrandMapping.has(savedCardBrand)) {
    throw Error('Unsupported credit card brand');
  }

  return SavedCardBrandMapping.get(savedCardBrand)!;
};

const getApiCreditCardBrand = (brand: string): CreditCardBrandInput => {
  const ApiBrandMapping = new Map<string, CreditCardBrandInput>([
    ['visa', 'VISA'],
    ['mastercard', 'MASTER_CARD'],
    ['amex', 'AMEX'],
    ['unknown', 'UNKNOWN'],
  ]);

  if (!ApiBrandMapping.has(brand)) {
    return ApiBrandMapping.get('unknown')!;
  }

  return ApiBrandMapping.get(brand)!;
};

export { getApiCreditCardBrand, getSavedCardBrand };
